module.exports = __webpack_public_path__ + "static/media/announce_withus_home.c718b68f.png";